import { serveSlackTopReactionInSearchExperiment } from '../../../../../../../common/utils/experiments';

export default {
	get(): boolean {
		return serveSlackTopReactionInSearchExperiment({ fireExperimentExposure: false });
	},
};
